var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" "+_vm._s(_vm.discountOn)+" "),(_vm.discountOnType)?_c('span',[_vm._v("/")]):_vm._e(),_vm._v(" "+_vm._s(_vm.discountOnType)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }